import ResourceLinkBlock from './resourceLinkBlock';


function ResourceList(props) {

  // Define variables
  const profileData = props.profileData;
  const organizationType = profileData.organizationType;


  // Screen components
  let quickStartClassElement;
  let quickStartTeamElement;
  let guideAddFlowPackageElement;
  let resourceAddFlowToPackageElement;

  if( organizationType != 'Business' ) {
    quickStartClassElement = (
      <ResourceLinkBlock
        subTitle={'Quick Start'}
        title={'Use FLOW With Your Class'}
        description={'Learn how to invite your students and set them up for speaking success.'}
        url={'/resources/quick-start-using-flow-with-your-class'}
      />
    );

    resourceAddFlowToPackageElement = (
      <ResourceLinkBlock
        subTitle={'Guide'}
        title={'Tips To Make FLOW Speak Successful In Your Class'}
        description={'7 tips to get your students engaged.'}
        url={'/resources/tips-for-class-success'}
      />
    );
  }

  if( organizationType === 'Business' || organizationType === 'Other' ) {
    quickStartTeamElement = (
      <ResourceLinkBlock
        subTitle={'Quick Start'}
        title={'Using FLOW With Your Team'}
        description={'Learn how to invite your team and set them up for speaking success.'}
        url={'/resources/quick-start-using-flow-with-your-team'}
      />
    );
  }

  if( organizationType === 'Independent teacher' ) {
    guideAddFlowPackageElement = (
      <ResourceLinkBlock
        subTitle={'Guide'}
        title={'Adding FLOW Speak to Your Learning Package'}
        description={'Learn how you can include FLOW Speak in your learning package.'}
        url={'/resources/guide-add-flow-to-your-learning-package'}
      />
    );
  }

  let activitiesElement;
  if( organizationType != 'Business' ) {
    activitiesElement = (
      <div style={{marginTop: '90px'}}>
        <h2>Classroom Activites</h2>
        <p style={{marginTop: '5px', marginBottom: '30px'}}>Classroom activities are free resources for you to use with your students. Each activity has a downloadable PDF that includes instructions, worksheets, any other items you need to do the activity in class.</p>

        <div class='flex-row resources-list'>
          <ResourceLinkBlock
            subTitle={'Module Plan'}
            title={'"On Vacation" Course Module Plan'}
            level={'B1'}
            description={'Everything you need to use the "On Vacation" coures with your class.'}
            url={'https://files.flowspeak.io/files/teaching-materials/8%20Week%20Module%20Plan%20-%20Using%20FLOW%20Speak%E2%80%99s%20%E2%80%9COn%20Vacation%E2%80%9D%20Course.pdf'}
          />

          <ResourceLinkBlock
            subTitle={'Activity'}
            title={'Past Work Experience'}
            level={'B1'}
            description={'Your students can learn to communicate with employers about past experience and transferable skills.'}
            url={'https://files.flowspeak.io/files/teaching-materials/FLOW%20Speak%20Activity%20-%20Past%20Work%20Experience.pdf'}
          />

          <ResourceLinkBlock
            subTitle={'Activity'}
            title={'Making a Return'}
            level={'B1'}
            description={'Your students can practice returning a purchase.'}
            url={'https://files.flowspeak.io/files/teaching-materials/FLOW%20Speak%20Activity%20-%20Making%20a%20Return.pdf'}
          />

          <ResourceLinkBlock
            subTitle={'Activity'}
            title={'Problems at the Airport'}
            level={'B1'}
            description={'Practice solving air travel problems and encourage speaking practice.'}
            url={'https://files.flowspeak.io/files/teaching-materials/FLOW%20Speak%20Activity%20-%20Problems%20at%20the%20Airport.pdf'}
          />

          <ResourceLinkBlock
            subTitle={'Activity'}
            title={'Self-Care Advice'}
            level={'B2'}
            description={'Practice mental health vocabulary and giving advice.'}
            url={'https://files.flowspeak.io/files/teaching-materials/FLOW%20Speak%20Activity%20-%20Self-Care%20Advice.pdf'}
          />

          <ResourceLinkBlock
            subTitle={'Activity'}
            title={'Grocery Shopping'}
            level={'A1-A2'}
            description={'Practice grocery store vocabulary and asking for help.'}
            url={'https://files.flowspeak.io/files/teaching-materials/FLOW%20Speak%20Activity%20-%20Grocery%20Shopping.pdf'}
          />

          <ResourceLinkBlock
            subTitle={'Activity'}
            title={'Planning A Holiday Dinner'}
            level={'A2'}
            description={'Ask your adult language learners to plan a holiday meal.'}
            url={'https://files.flowspeak.io/files/teaching-materials/FLOW%20Speak%20Activity%20-%20Planning%20a%20holiday%20dinner.pdf'}
          />

          <ResourceLinkBlock
            subTitle={'Activity'}
            title={'Packing for a Trip'}
            level={'A2'}
            description={'Learners create a packing list based on location, trip duration, and weather.'}
            url={'https://www.flowspeak.io/articles/packing-for-a-trip'}
          />

        </div>
      </div>
    );
  }


  return (
    <div class='resources-container'>
      <h2>Resources</h2>
      <br />

      <div class='flex-row resources-list'>

        <ResourceLinkBlock
          subTitle={'User Manual'}
          title={'FLOW Administrator Manual'}
          description={'Everything you need to know about how to use the FLOW Admin.'}
          url={'https://files.flowspeak.io/files/resources/FLOW%20Administrator%20Manual.pdf'}
        />

        {quickStartClassElement}
        {quickStartTeamElement}
        {guideAddFlowPackageElement}
        {resourceAddFlowToPackageElement}

        <ResourceLinkBlock
          subTitle={'Reference'}
          title={'Course List'}
          description={'See all the FLOW Speak Courses and their lessons.'}
          url={'/resources/courses'}
        />

        <ResourceLinkBlock
          subTitle={'Reference'}
          title={'Pathway List'}
          description={'See all the FLOW Speak Pathways and their lessons.'}
          url={'/resources/pathways'}
        />

      </div>

      {activitiesElement}
    </div>
  );
}

export default ResourceList;